import { apiGet, apiPatch } from './client';
import type { SwapInterestType, SwapInterestTypeBatchRequest } from '../types/SwapInterestType';

export function getSwapInterestTypes(): Promise<SwapInterestType[]> {
  return apiGet<SwapInterestType[]>('/api/swap-interest-types');
}

export function saveBatchSwapInterestTypes(added: SwapInterestType[], modified: SwapInterestType[], deletedIds: number[]): Promise<SwapInterestType[]> {
  return apiPatch<SwapInterestTypeBatchRequest, SwapInterestType[]>('/api/swap-interest-types/batch', { added, modified, deleted: deletedIds });
}
